<div
    class="mp-total-orders-card trezo-card mb-25 border-radius d-block bg-white border-0 shadow-none"
    [class.component-dark-theme]="themeService.isDark()"
>
    <div class="trezo-card-content">
        <span class="d-block">
            Total Orders
        </span>
        <h5 class="mb-0">
            25k+
        </h5>
        <div class="icon mx-auto text-purple bg-purple-100 rounded-circle mx-auto d-flex align-items-center justify-content-center">
            <i class="material-symbols-outlined">
                orders
            </i>
        </div>
        <div class="info d-flex align-items-center justify-content-between">
            <span class="d-block">
                This Month
            </span>
            <span class="lh-1 text-danger">
                <i class="material-symbols-outlined">
                    trending_down
                </i>
            </span>
        </div>
    </div>
</div>